module.exports = __webpack_public_path__ + "static/media/manzo_05_thumb_hover.6442fa28.png";